<div class="flex flex-col h-full">
  <!-- header -->
  <div
    class="flex flex-row items-center py-2 pl-3 text-xl font-medium border-b border-gray-1"
    data-cy="clip-and-save-panel-header"
  >
    {{ translations.title.text }}
    <div class="flex flex-1 justify-end mr-2">
      <button
        id="clip-and-save-panel-close"
        class="text-gray-8"
        modus-icon-button
        modus-tooltip="{{ dismissLabel() }}"
        [disabled]="isSubmitting()"
        (click)="cancelClick()"
      >
        <md-icon>close</md-icon>
      </button>
    </div>
  </div>

  <!-- content (scrollable) -->
  <div class="flex flex-col flex-1 overflow-y-auto p-4 gap-4">
    @if (!submitSuccess()) {
      <p class="text-sm text-gray-8 m-0">{{ descriptionText() }}</p>
    }

    @if (showCrsMismatchWarning()) {
      <modus-alert
        class="w-full"
        type="warning"
        [message]="translations.crsMismatchWarning.text"
      ></modus-alert>
    }

    @if (submitSuccess()) {
      <modus-alert
        class="w-full"
        type="success"
        [message]="translations.submitSuccess.text"
      ></modus-alert>
    }

    @if (!submitSuccess()) {
      <div class="flex flex-col">
        <modus-label class="text-xs">{{ translations.name.label.text }}</modus-label>
        <modus-form-field [hideRequiredMarker]="true">
          <input
            auto-focus
            modus-input
            data-cy="clip-and-save-name-input"
            [formControl]="nameControl"
            placeholder="{{ translations.name.placeholder.text }}"
            maxlength="200"
          />
        </modus-form-field>
      </div>

      @if (submitError()) {
        <modus-alert class="w-full" type="error" [message]="submitError()"></modus-alert>
      }
    }
  </div>

  <!-- footer actions -->
  <div class="flex flex-row justify-end gap-2 px-4 py-3 border-t border-gray-1">
    <button
      id="clip-and-save-panel-cancel"
      modus-button
      color="secondary"
      [disabled]="isSubmitting()"
      (click)="cancelClick()"
    >
      {{ dismissLabel() }}
    </button>
    @if (!submitSuccess()) {
      <button
        id="clip-and-save-panel-submit"
        modus-flat-button
        color="primary"
        [disabled]="disableSubmit()"
        (click)="submitClick()"
      >
        {{ translations.submit.text }}
      </button>
    }
  </div>
</div>
